$shm_hitalama_map_widget_float_chart_filter $shm_hitalama_map_widget_float
	content /
		<= Form $mol_list
			sub /
				<= Field $mol_form_field
					name <= field_name \
					Content <= Filter_options $shm_check_list
						options <= filter_options /
						value? <=> filter_options_checked? /
